import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-calendar/dist/Calendar.css";

import StoreProvider from "./shared/store/store.provider";
import { DrawerProvider, ThemeProvider } from "./shared/store/contexts";

import NotFoundPage from "./patterns/pages/404";

import LoginPage from "./patterns/pages/Login";

import DashboardHome from "./patterns/pages/DashboardHome";

import ReferralFormPage from "./patterns/pages/ReferralFormPage";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <>
      <ScrollToTop />
      <DrawerProvider>
        <StoreProvider>
          <ThemeProvider>
            <Routes>
              <Route path="/404" element={<NotFoundPage />} />
              <Route path="/dashboard/*" element={<DashboardHome />} />
              {/* edit this page below when referral form json is provided */}
              <Route path="/referral-form/:url" element={<ReferralFormPage />} />
              <Route path="/" element={<LoginPage />} />
              {/* <Route path="/login" element={<LoginPage />} /> */}
              <Route path="*" element={<NotFoundPage />} /> {/* Handle 404 */}
            </Routes>
          </ThemeProvider>
        </StoreProvider>
      </DrawerProvider>
      <ToastContainer autoClose={4000} />
    </>
  );
}

export default App;
